import React from 'react';
import './notifier.scss';
import { Icon } from "../../index";
import { Collapse } from 'reactstrap';

export const NotifierAccordion = ({
    accordion,
    iconContent,
    headingContent,
    bodyContent,
    linkContent
}) => {

    return <>
        <button
            type="button"
            className="bsw-notifier__accordion-heading"
            onClick={accordion?.toggle}
        >
            {iconContent && iconContent}
            <div className="bsw-notifier__message-heading">
                {headingContent && headingContent}
                <div className="bsw-notifier__accordion-arrow">
                    <Icon name={accordion.open ? "chevron-up" : "chevron-down"}
                        color={"$color-primary-a2"}
                        size="medium" />
                </div>
            </div>
        </button>
        <Collapse
            className={`bsw-notifier__accordion-body ${iconContent ? 'bsw-notifier__accordion-body--indent' : ''}`}
            isOpen={accordion?.open}
        >
            <div className="bsw-notifier__message">
                {bodyContent && bodyContent}
                {linkContent && linkContent}
            </div>
        </Collapse>
    </>;
}